module.exports = __webpack_public_path__ + "img/ic-incoming.a9b53c82.svg";